import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { get } from 'lodash';
import { reset } from 'redux-form';
import { connect } from 'react-redux';
import { styles } from './formStyles';
import { POST_NEW_BET } from '../../redux/OffersDetails';
import { BETS_INPUT_INITIAL, USER_TYPED_INVALID_BET, USER_TYPED_VALID_BET } from '../../redux/BetsFormValidation';
import AuctionForm from './AuctionForm';
import BuyNowForm from './BuyNowForm';
import { SET_MODAL } from '../../redux/Modal';

const AuctionFormContainer = ({ dealerBetHighest, offerId, resetForm, buyNowContract, errorBetsDetails,
    postNewBet, highestBetValue, setModal, }) => {
  const handleSubmit = (values) => {
    postNewBet({ offerId, value: get(values, 'value'), });
    resetForm();
  };

  const classes = useStyles();

  return (
    <div className={classes.auctionFromContainer}>

      {buyNowContract &&
        <BuyNowForm
          buyNowContract={buyNowContract}
          setModal={setModal}
        />
      }

      <AuctionForm
        dealerBetHighest={dealerBetHighest}
        onSubmit={handleSubmit}
        highestBetValue={highestBetValue}
        errorBetsDetails={errorBetsDetails}
      />

    </div>
  );
};

AuctionFormContainer.propTypes = {
  buyNowContract: PropTypes.object,
  setModal: PropTypes.func.isRequired,
  highestBetValue: PropTypes.number,
  postNewBet: PropTypes.func.isRequired,
  offerId: PropTypes.string.isRequired,
  resetForm: PropTypes.func.isRequired,
  errorBetsDetails: PropTypes.string,
  dealerBetHighest: PropTypes.bool,
};

AuctionFormContainer.defaultProps = {
  buyNowContract: null,
  highestBetValue: 0,
  errorBetsDetails: null,
  dealerBetHighest: false,
};

const mapDispatchToProps = (dispatch) => {
  return {
    postNewBet: (params) => dispatch(POST_NEW_BET(params)),
    inputValid: () => dispatch(USER_TYPED_VALID_BET()),
    inputInvalid: () => dispatch(USER_TYPED_INVALID_BET()),
    inputInitial: () => dispatch(BETS_INPUT_INITIAL()),
    resetForm: () => dispatch(reset('auctionForm')),
    setModal: (params) => dispatch(SET_MODAL(params)),
  };
};

const mapStateToProps = (state) => {
  return {
    buyNowContract: get(state, ['offerDetails', 'data', 'buy_now_contract']),
    highestBetValue: get(state, ['offerDetails', 'data', 'highest_bet_value']),
    dealerBetHighest: get(state, ['offerDetails', 'data', 'my_bet_is_highest']),
    errorBetsDetails: get(state, ['offerDetails', 'errorBetsDetails']),
    isMobile: get(state, ['layout', 'isMobile']),
  };
};

const useStyles = createUseStyles({
  auctionFromContainer: {
    padding: '1.5em',
    display: 'flex',
    backgroundColor: styles.colors.lightGray,
    flexDirection: 'column',
    border: `1px solid ${styles.colors.grayBorder}`,
  },
  button: {
    width: '100%',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AuctionFormContainer);

